import { useMemo } from "react";
import useSmartAndRegularAssets from "./useSmartAndRegularAssets";

// This hook is used to determine if an entity is a critical asset
const useEntityIsCriticalAsset = () => {
  // Get the list of regular and active smart assets
  const { regularAndActiveSmartAsset: assets, isLoadingAll: assetsAreLoading } =
    useSmartAndRegularAssets(false); // Create a set of entity ids that are in the assets list
  // add useMemo to avoid recalculating the set on every render
  const entityIdsInAsset = useMemo(() => {
    const ids = new Set();
    assets?.forEach((asset) => {
      asset.entity_ids.forEach((entityId) => {
        ids.add(entityId);
      });
    });
    return ids;
  }, [assets]);

  // Function to check if an entity is a critical asset
  const entityIsCriticalAsset = (entity_id) => {
    return entityIdsInAsset.has(entity_id);
  };
  // Function to get the asset an entity is involved in
  const getAssetByEntityId = (entity_id) => {
    return (
      assets?.find((asset) => asset.entity_ids.includes(entity_id)) || null
    );
  };

  return { entityIsCriticalAsset, getAssetByEntityId, assetsAreLoading };
};

export default useEntityIsCriticalAsset;
